/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderBenchmarkDimension', 'model/StakeholderBenchmarkDimensionReport', 'model/StakeholderBenchmarkDimensionReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StakeholderBenchmarkDimension'), require('../model/StakeholderBenchmarkDimensionReport'), require('../model/StakeholderBenchmarkDimensionReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderBenchmarkDimensionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderBenchmarkDimension, root.ForStractionServiceApi.StakeholderBenchmarkDimensionReport, root.ForStractionServiceApi.StakeholderBenchmarkDimensionReportPaginationSlice);
  }
}(this, function(ApiClient, StakeholderBenchmarkDimension, StakeholderBenchmarkDimensionReport, StakeholderBenchmarkDimensionReportPaginationSlice) {
  'use strict';

  /**
   * StakeholderBenchmarkDimension service.
   * @module api/StakeholderBenchmarkDimensionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderBenchmarkDimensionApi. 
   * @alias module:api/StakeholderBenchmarkDimensionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionAddAllPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderBenchmarkDimension>} body 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.stakeholderBenchmarkDimensionAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionAddPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimension} body 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderBenchmarkDimensionAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionDeleteAllPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionDeleteGet operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} dimensionID 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionDeleteGet = function(_4SAPIAppID, dimensionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionDeleteGet";
      }

      // verify the required parameter 'dimensionID' is set
      if (dimensionID == undefined || dimensionID == null) {
        throw "Missing the required parameter 'dimensionID' when calling stakeholderBenchmarkDimensionDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'dimensionID': dimensionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionEditAllPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderBenchmarkDimension>} body 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionEditPut operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimension} body 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderBenchmarkDimensionEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionLoadAllGet operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StakeholderBenchmarkDimensionReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StakeholderBenchmarkDimensionReport>}
     */
    this.stakeholderBenchmarkDimensionLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StakeholderBenchmarkDimensionReport];

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionLoadGet operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderBenchmarkDimensionReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} dimensionID 
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderBenchmarkDimensionReport}
     */
    this.stakeholderBenchmarkDimensionLoadGet = function(_4SAPIAppID, dimensionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionLoadGet";
      }

      // verify the required parameter 'dimensionID' is set
      if (dimensionID == undefined || dimensionID == null) {
        throw "Missing the required parameter 'dimensionID' when calling stakeholderBenchmarkDimensionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'dimensionID': dimensionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderBenchmarkDimensionReport;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderBenchmarkDimensionSearchSlicePut operation.
     * @callback module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderBenchmarkDimensionReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderBenchmarkDimension} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StakeholderBenchmarkDimensionApi~stakeholderBenchmarkDimensionSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderBenchmarkDimensionReportPaginationSlice}
     */
    this.stakeholderBenchmarkDimensionSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderBenchmarkDimensionSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderBenchmarkDimensionSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderBenchmarkDimensionReportPaginationSlice;

      return this.apiClient.callApi(
        '/StakeholderBenchmarkDimension/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
